import Vue from "vue"

export default new Vue({
  name: "AssetStatusService",
  data: {},
  methods: {}
})



// WEBPACK FOOTER //
// ./src/AssetStatus/AssetStatusService.js